"use client";

import { PropsWithChildren } from "react";
import { useTheme } from "@/contexts/ThemeContext";

export function Title(props: PropsWithChildren & { language?: string }) {
  const { themeColors } = useTheme();
  const fontClass =
    props.language === "kr" ? "font-noto-sans" : "font-helvetica";

  return (
    <h1
      className={`text-xlarge md:text-jumbo lg:text-jumbo font-semibold ${themeColors.headerTextColor} text-pretty ${fontClass}`}
    >
      {props.children}
    </h1>
  );
}
